import { Component, OnInit, Injectable, Injector, ChangeDetectionStrategy } from '@angular/core';
import { GoogleTagService } from 'src/app/core/tag/google-tag.service';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { Title } from '@angular/platform-browser';

import { BaseComponents } from '../../base.component';

declare var window: any;
@Component({
    selector: 'app-add-line-tisco',
    templateUrl: './add-line-tisco.component.html',
    styleUrls: ['./add-line-tisco.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

@Injectable()
export class AddLineTiscoComponent extends BaseComponents implements OnInit {
  permission_recoding: Observable<boolean>;
  constructor(
    protected injectorObj:Injector,
    private googleTageService: GoogleTagService,
    private titleService: Title
  ) { 
    super(injectorObj);
  }

  async ngOnInit() {
   
    const url = new URL(window.location.href);
    const path = url.pathname.split('/');
    // console.log(path);
    if (path[1].toLocaleLowerCase() == 'mazda-motorshow') {
      this.titleService.setTitle("Mazda add line");
    } else if (path[1].toLocaleLowerCase() == 'ford-motorshow') {
      this.titleService.setTitle("Ford add line");
    } else if (path[1].toLocaleLowerCase() == 'mitsubishi-motorshow') {
      this.titleService.setTitle("Mitsubishi add line");
    }
    if ((environment.log_level) == 'debug') {
      window.vConsole = new window.VConsole();
    }
    this.permission_recoding = await this.googleTageService.permission;
    setTimeout(() => {
      console.log(environment.motorshowLine);
      if (environment.motorshowLine) {
        window.location.href = `https://line.me/ti/p/${encodeURIComponent(environment.motorshowLine)}`;
      }
    }, 1000);
  }

}
